<template>
  <div class="row q-pa-md items-center">
    <div style="display: inline-block" class="text-h6">Registration</div>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="addMember"
      :disable="!event"
      dense
    >
      <q-icon size="xs" name="mdi-plus-circle"></q-icon>
    </q-btn>

    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="$store.dispatch('settings/toggleVirtualScrolling')"
      dense
      v-if="$q.screen.gt.xs"
    >
      <q-icon size="xs" name="mdi-printer" class="q-mr-sm"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="startScanner"
      dense
    >
      <q-icon size="xs" name="mdi-nfc-variant"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="registerAll"
      :loading="registerAllLoading"
      dense
    >
      <q-icon size="xs" name="mdi-check" class="q-mr-sm"></q-icon>
      Mark all
    </q-btn>
    <q-space />
    <!-- <q-input
      style="max-width: 70%"
      filled
      v-model="rfid"
      debounce="200"
      label="Scan RFID"
      clearable
      dense
    >
      <template #prepend>
        <q-icon name="mdi-magnify"> </q-icon>
      </template>
    </q-input> -->
    <div
      class="col-12 mt-0 pt-0"
      :style="
        `${
          !disableVirtualScrolling
            ? 'height: calc(100vh - 260px) !important'
            : ''
        }`
      "
    >
      <datatable
        :filter="search"
        :flat="true"
        :data="gridData"
        :v-scroll="!disableVirtualScrolling"
        :columns="columns"
        @rowDoubleClick="handleDoubleClick"
        :hidePagination="true"
      >
        <template slot="body-cell-id" slot-scope="data">
          <q-td :props="data.props">
            <div class="row items-center">
              <q-checkbox
                v-model="registrationData[data.props.row.id].value"
                :true-value="1"
                :false-value="0"
                @input="updateRegistrationValue(data.props.row.id)"
                dense
                v-if="data.props.row.scratched != 1"
              ></q-checkbox>
              <q-icon
                v-if="data.props.row.scratched == 1"
                name="mdi-close"
                color="negative"
                size="20px"
              >
              </q-icon>
              <q-btn dense round flat class="float-right" color="black">
                <q-icon name="mdi-dots-vertical"></q-icon>
                <q-menu>
                  <q-list style="min-width: 100px">
                    <q-item
                      @click="scratch(data.props.row)"
                      clickable
                      v-close-popup
                    >
                      <q-item-section>Scratch/Unscratch</q-item-section>
                    </q-item>
                    <q-separator v-if="data.props.row.team_name" />
                  </q-list>
                </q-menu>
              </q-btn>
            </div>
          </q-td>
        </template>
        <template slot="body-cell-capUrl" slot-scope="data">
          <q-td :props="data.props">
            <q-img
              v-if="data.props.row.capUrl"
              :src="data.props.row.capUrl"
              style="width: 40px"
              contain
            >
            </q-img>
            <q-img
              v-else
              src="https://nzsls.s3.ap-southeast-2.amazonaws.com/associationAssets/Composite+Teams+Cap.png"
              style="width: 40px"
              contain
            >
            </q-img>
          </q-td>
        </template>
        <template slot="body-cell-firstName" slot-scope="data">
          <q-td
            v-if="!data.props.row.team_name"
            :props="data.props"
            :style="
              `${
                data.props.row.scratched ? 'text-decoration: line-through;' : ''
              }; line-height: 14px`
            "
          >
            {{ data.props.row.firstName }} {{ data.props.row.lastName }}
            <q-icon
              v-if="data.props.row.rfid"
              color="blue-grey"
              size="xs"
              name="mdi-tag-text"
            >
              <q-tooltip>RFID - {{ data.props.row.rfid }}</q-tooltip>
            </q-icon>
            <br />
            <span style="font-size: 10px; font-weight: bold;">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
          <q-td
            v-else
            :props="data.props"
            :style="
              `${
                data.props.row.scratched ? 'text-decoration: line-through;' : ''
              }; line-height: 14px`
            "
          >
            <b>{{ data.props.row.team_name }}</b> <br />
            <span
              style="font-size: 10px; "
              v-for="(member, index) in data.props.row.members"
              :key="`member_${index}`"
            >
              {{ member.firstName }} {{ member.lastName }}
              {{ index < data.props.row.members.length - 1 ? ", " : "" }} </span
            ><br />
            <span style="font-size: 10px; font-weight: bold;">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
        </template>
        <template slot="body-cell-association_abbr" slot-scope="data">
          <q-td :props="data.props">
            {{ data.props.row.association_abbr }}
          </q-td>
        </template>
        <template slot="body-cell-actions" slot-scope="data">
          <q-td :props="data.props"> </q-td>
        </template>
      </datatable>
    </div>
    <q-dialog v-model="teamDetailsModel">
      <teamDetailsCard :team="currentTeamDetails" />
    </q-dialog>
    <!-- <q-dialog v-model="addMemberDialog">
      <teamDetailsCard />
    </q-dialog> -->
    <q-dialog
      :maximized="$q.screen.lt.sm"
      v-model="addTeamDialog"
      persistent
      max-width="90vw"
    >
      <q-card v-if="addTeamDialog" tile style="width: 90vw; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <q-btn
              round
              flat
              icon="mdi-close"
              class="float-right"
              @click="addTeamDialog = false"
            >
            </q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <teamEntryForm
            :id="$route.params.events_id"
            fromWaves
            @close="addTeamDialog = false"
            @newTeamEntered="
              $store.dispatch(
                'events/loadParticipantsForEvent',
                $route.params.events_id
              );
              $store.dispatch(
                'events/loadRegistrationData',
                $route.params.events_id
              );
            "
          />
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog
      :maximized="$q.screen.lt.sm"
      v-model="addMemberDialog"
      persistent
      max-width="90vw"
    >
      <q-card v-if="addMemberDialog" tile style="width: 90vw; max-width: 90vw">
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center">
            <q-btn
              round
              flat
              icon="mdi-arrow-left"
              @click="addMemberDialog = false"
            >
            </q-btn>
            <h3 style="font-size: 20px" class="q-my-none">
              {{ event.event_name }}
            </h3>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section>
          <individualEntryForm
            :id="$route.params.events_id"
            :events_id="$route.params.events_id"
            fromWaves
            @close="addMemberDialog = false"
            @newTeamEntered="
              $store.dispatch(
                'events/loadParticipantsForEvent',
                $route.params.events_id
              );
              $store.dispatch(
                'events/loadRegistrationData',
                $route.params.events_id
              );
            "
          />
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import datatable from "@/components/datatable/datatable.vue";
import teamDetailsCard from "@/components/wavesProgress/teamDetailsCard.vue";
import teamEntryForm from "@/components/competitions/teamEntryForm.vue";
import individualEntryForm from "@/components/competitions/individualEntryForm.vue";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    teamDetailsCard,
    teamEntryForm,
    individualEntryForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      gridData: "events/participantList",
      gridDataLoading: "events/participantListLoading",
      registrationData: "events/registrationData",
      event: "events/current",
      disableVirtualScrolling: "settings/disableVirtualScrolling"
    }),
    columns: function() {
      return [
        {
          name: "id",
          label: "",
          align: "left",
          field: "id",
          style:
            "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
        },
        {
          name: "capUrl",
          label: "Club",
          align: "left",
          field: "capUrl",
          style:
            "min-width: 80px;max-width: 80px; width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "firstName",
          label: "Name",
          align: "left",
          field: "firstName",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "event_name",
          label: "Event",
          align: "left",
          field: "event_name",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            !this.event.combinedEvents || this.event.combinedEvents.length < 1,
          sortable: true
        }

        // {
        //   name: "association_abbr",
        //   label: "Club",
        //   align: "left",
        //   field: "association_abbr",
        //   style:
        //     "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        //   sortable: true
        // }
      ];
    }
  },
  data: () => ({
    rfid: "",
    search: "",

    // Data Table

    teamDetailsModel: false,
    currentTeamDetails: {},
    registerAllLoading: false,

    // Add Member Dialog
    addMemberDialog: false,
    addTeamDialog: false,

    // NFC
    nfcScanner: null,
    handleReading: null
  }),
  watch: {},
  mounted() {},
  methods: {
    handleDoubleClick() {
      // console.log(2);
    },
    addMember() {
      if (JSON.parse(this.event.playerLabels).length < 2) {
        this.addMemberDialog = true;
      } else {
        this.addTeamDialog = true;
      }
    },
    updateRegistrationValue(id) {
      this.$store
        .dispatch("events/updateRegistrationValue", this.registrationData[id])
        .then(result => {
          if (result.Result == "Success") {
            this.registrationData[id].id = result.Response.ID;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    async updateProgress() {
      let unRegisteredMembers = [];

      this.gridData.forEach(p => {
        if (!this.registrationData[p.id].value && p.scratched != 1) {
          unRegisteredMembers.push(p);
        }
      });

      if (unRegisteredMembers.length) {
        let res = await this.$swal({
          title: "Warning",
          text: `There are ${unRegisteredMembers.length} athletes/teams not registered. Continuing will scratch those members, did you want to continue?`,
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122"
        });
        if (res.value) {
          unRegisteredMembers.forEach(p => {
            this.scratch(p);
          });
        } else {
          return false;
        }
      }

      let result = await this.$store.dispatch(
        "eventProgress/submitRegistration",
        {
          id: this.$route.params.events_id
        }
      );

      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later"
        });
      }

      return result;
    },
    registerAll() {
      this.registerAllLoading = true;
      let notRegistered = this.gridData.filter(p => {
        return (
          (!this.registrationData[p.id] ||
            !this.registrationData[p.id].value) &&
          p.scratched == 0
        );
      });
      this.$store
        .dispatch("events/registerAll", {
          id: this.$route.params.events_id,
          value: notRegistered.length > 0 ? 1 : 0
        })
        .then(result => {
          this.registerAllLoading = false;
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$store.dispatch(
              "events/loadParticipantsForEvent",
              this.$route.params.events_id
            );
            this.$store.dispatch(
              "events/loadRegistrationData",
              this.$route.params.events_id
            );
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    scratch(row) {
      row.scratched = row.scratched == 1 ? 0 : 1;
      this.registrationData[row.id].value = 0;
      this.updateRegistrationValue(row.id);
      this.$store.dispatch("eventProgress/scratchMember", {
        id: row.id,
        value: row.scratched,
        isTeamEvent: JSON.parse(this.event.playerLabels).length > 1
      });
    },

    // Start Scanner
    async handleNFCScan(message, serialNumber, extraData) {
      // ADD NFC to Member
      try {
        // Find Member Via NFC
        let NFCFound = false;

        // Team
        if (this.gridData[0].team_name) {
          this.gridData.forEach(team => {
            team.members.forEach(member => {
              member.NFCTags.forEach(tag => {
                if (tag.serialNumber == serialNumber) {
                  this.registrationData[team.id].value = 1;
                  this.updateRegistrationValue(team.id);
                  NFCFound = true;
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: "Member Scanned Successfully"
                  });
                }
              });
            });
          });
        } else {
          // Individual
          this.gridData.forEach(member => {
            member.NFCTags.forEach(tag => {
              if (tag.serialNumber == serialNumber) {
                this.registrationData[member.id].value = 1;
                this.updateRegistrationValue(member.id);
                NFCFound = true;
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Member Scanned Successfully"
                });
              }
            });
          });
        }

        if (!NFCFound) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Member Not Found"
          });
        }
      } catch (error) {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    startScanner() {
      this.$store.dispatch("NFC/startScanner", {
        $this: this,
        handleNFCScan: this.handleNFCScan
      });

      // this.handleNFCScan(null, "test", null);
    }
  }
};
</script>
